// libs
import React, { memo } from "react";
import styled from "@emotion/styled";

// constants
import { TEXTS } from "shared/components/AuthModal/constants";

// styled components
const Container = styled.div`
    font-size: 0.85rem;
    color: #000;
    margin-top: 15px;
`;

function Terms() {
    return (
        <Container>
            {TEXTS.BY_SIGNING}{" "}
            <a
                href="https://www.nykaafashion.com/terms-and-conditions.html?root=footer"
                target="_blank"
            >
                {TEXTS.TERMS}
            </a>
        </Container>
    );
}

export default memo(Terms);
